module.exports = __webpack_public_path__ + "static/kvm_3.068f1e23.jpg";